import api from './axios';

export const placeOrderApi  = (data) => api.post('/orders', data);
export const getOrdersApi   = ()     => api.get('/orders');
export const getOrderApi    = (id)   => api.get(`/orders/${id}`);
export const cancelOrderApi = (id)   => api.patch(`/orders/${id}/cancel`);
